$(function () {

    $(window).on('resize', function () {  
        if($('.collapse').hasClass('active')) {
            $('.dropdown-menu').removeClass('active').slideUp('fade');
            $('.nav-item.dropdown').removeClass('active');
            $('.dropdown-menu-toggler').removeClass('active');
            $('html, body').css('overflow', '');
            $('.collapse').removeClass('active');
        }
    });

    // Open menu
    $(document).on('click', '.header__content__toggle, .collapse__close', function() {
        $('.dropdown-menu').removeClass('active').slideUp('fade');
        $('.nav-item.dropdown').removeClass('active');
        $('.dropdown-menu-toggler').removeClass('active');
        
        if ($(window).width() > 1200) {
            var height = $('.collapse .collapse__wrapper--inner').height();
            var view = $(window).height();
            var padding = (view-height)/2;
            if(padding < 50){
                padding = '9rem';
            }
            $('.collapse__wrapper').css('padding-top', padding);
        }

        if($(this).hasClass('collapsed')) {
            $('html, body').css('overflow', 'hidden');
        }else{
            $('html, body').css('overflow', '');
        }
            
        $('.collapse').toggleClass('active');
        $('.collapse__close').css('left', $('.header__content__toggle__span').offset().left);
    });

    $('.nav-link.has-dropdown[href="#"]').on('click', function() {
        // Alle andere submenu's hiden
        $('.dropdown-menu').removeClass('active').not($(this).next().next()).slideUp('fade');
        $('.nav-item.dropdown').not($(this).parent()).removeClass('active');
        $('.dropdown-menu-toggler').not($(this).next()).removeClass('active');
   
        // Huidige submenu showen
        // $(this).parent().toggleClass('active');
        $(this).next().toggleClass('active');
        $(this).next().next().addClass('active');

        if($(this).next().next().is(':visible')) {
            $($(this).next().next()).slideUp( 'fade', function() {
                $('.dropdown-menu li').removeAttr('style');
                $('.dropdown-menu').removeClass('active');
            });
        }else{
            $('.dropdown-menu:not(.active) li').removeAttr('style');

            $($(this).next().next()).slideDown( 250 );
            $('.dropdown-menu.active li').each(function(index) {
                $(this).delay(100*index).animate({ opacity: 1 }, 100,function(){
                    $(this).css('transform','translateX(0)');
                });
            });
        }
    })

    // Open submenu
    $('.dropdown-menu-toggler').on('click', function () {
        // Alle andere submenu's hiden
        $('.dropdown-menu').removeClass('active').not($(this).next()).slideUp('fade');
        $('.nav-item.dropdown').not($(this).parent()).removeClass('active');
        $('.dropdown-menu-toggler').not($(this)).removeClass('active');
   
        // Huidige submenu showen
        // $(this).parent().toggleClass('active');
        $(this).toggleClass('active');
        $(this).next().addClass('active');

        if($(this).next().is(':visible')) {
            $($(this).next()).slideUp( 'fade', function() {
                $('.dropdown-menu li').removeAttr('style');
                $('.dropdown-menu').removeClass('active');
            });
        }else{
            $('.dropdown-menu:not(.active) li').removeAttr('style');

            $('.dropdown-menu:not(.active) li').removeAttr('style');
            $($(this).next()).slideDown( 250 );
            $('.dropdown-menu.active li').each(function(index) {
                $(this).delay(100*index).animate({ opacity: 1 }, 100,function(){
                    $(this).css('transform','translateX(0)');
                });
            });
        }
    });

    $(window).on('resize', function () {  
        $('.collapse__close').css('left', $('.header__content__toggle__span').offset().left);
    });
});

$(document).keydown(function(event) {
    if (event.keyCode == 27) {
        if($('.collapse').hasClass('active')) {
            $('html, body').css('overflow', '');
            $('.collapse').removeClass('active');
        }
    }
});
